import { SelectOption } from '@Components/Selectors/Select'
import { RadioOption } from '@App/forms/common/radio-discriminated-form-field'

export const titleTypeOptions: SelectOption[] = [
    {
        id: '9',
        value: 'TE',
        label: 'First Line Of Text',
    },
    {
        id: '10',
        value: 'FT',
        label: 'Formal Title ',
    },
    {
        id: '11',
        value: 'IT',
        label: 'Incorrect Title',
    },
    {
        id: '12',
        value: 'OT',
        label: 'Original Title',
    },
    {
        id: '13',
        value: 'TT',
        label: 'Original Title Translated',
    },
    {
        id: '14',
        value: 'PT',
        label: 'Part Title',
    },
    {
        id: '15',
        value: 'RT',
        label: 'Restricted Title',
    },
    {
        id: '16',
        value: 'ET',
        label: 'Extra Search Title',
    },
    {
        id: '17',
        value: 'OL',
        label: 'Original Title With National Characters',
    },
    {
        id: '18',
        value: 'AL',
        label: 'Alternative Title With National Characters',
    },
    {
        id: '29',
        value: 'AT',
        label: 'Alternative Title',
    },
]

export const contactTypeOptions: SelectOption[] = [
    {
        label: 'Public',
        value: 'PUBLIC',
        id: '1',
    },
    {
        label: 'Finance',
        value: 'FINANCE',
        id: '2',
    },
    {
        label: 'Legal',
        value: 'LEGAL',
        id: '3',
    },
    {
        label: 'Copyright',
        value: 'COPYRIGHT',
        id: '4',
    },
]
export const unmatchedValueOptions: RadioOption[] = [
    { label: 'All', name: '', default: true },
    { label: '$$$$$', name: '5' },
    { label: '$$$$', name: '4' },
    { label: '$$$', name: '3' },
    { label: '$$', name: '2' },
    { label: '$', name: '1' },
]

export const sourceValues: RadioOption[] = [
    { label: 'All', name: '', default: true },
    { label: 'Blanket License', name: 'regular' },
    { label: 'Historical Unmatched', name: 'historic' },
]
